/**
 * OnboardingStep1.tsx - Personal Interests
 * First step of the onboarding flow.
 * Allows users to select interests (multi-select chip interface).
 * Uses design system utilities for consistent styling.
 */

import InterestsEditor from "../preferences/editors/InterestsEditor";
import OnboardingStepHeader from "./common/OnboardingStepHeader";
import { View } from "react-native";
import { spacingStyles } from "../../../styles/design-system";

export interface OnboardingStep1Props {
  selectedInterests: string[];
  onInterestsChange: (interests: string[]) => void;
}

function OnboardingStep1({ selectedInterests, onInterestsChange }: OnboardingStep1Props) {
  return (
    <View style={[spacingStyles.mNone]}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step1_title"
        subtitleKey="companion_onboarding_step1_subtitle"
      />
      <InterestsEditor value={selectedInterests} onChange={onInterestsChange} />
    </View>
  );
}

export default OnboardingStep1;
